/**
 * 左侧导航定宽度
 * bai.Zhiming
 * 2018-03-28
 */
"use strict";
angular.module("leftLiWidthModule", []).
directive("leftLiWidth", ["$timeout", function($timeout) {
    return {
        restrict: "A",
        scope: false,
        link: function(scope, $elem, $attrs) {
            var $lis;
            var $uls;
            var promise;
            watchInsert();
            /**
             * [watchInsert description] 监控内部元素变化
             * @return {[type]} [description]
             */
            function watchInsert() {
                $elem.bind('DOMNodeInserted', function(e) {
                    getWidth();
                });
            }
            /**
             * [init description]
             * @return {[type]} [description]*/
            function getWidth() {
                var liWidthArray = [];
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function() {
                    try {
                        $lis = $elem.find("li");
                        $uls = $elem.find("ul");
                        $lis.width("100%").css("overflow", "visible");
                        $uls.width("100%");
                        $lis.each(function() {
                            var spanWidth = $(this).find("span").length > 0 ? $(this).find("span")[0].offsetWidth : 0;
                            var spanMarginLeft = $(this).find("span").length > 0 ? Number($(this).find("span").css("marginLeft").replace(/px/, "")) : 0;
                            var spanMarginRight = $(this).find("span").length > 0 ? Number($(this).find("span").css("marginRight").replace(/px/, "")) : 0;
                            var spanLeft = $(this).find("span").length > 0 ? Number($(this).find("span").css("left").replace(/px/, "")) : 0;
                            spanLeft = isNaN(spanLeft) ? 0 : spanLeft;
                            var fontWidth = $(this).find("font").length > 0 ? $(this).find("font")[0].offsetWidth : 0;
                            var fontMarginLeft = $(this).find("font").length > 0 ? Number($(this).find("font").css("marginLeft").replace(/px/, "")) : 0;
                            var fontMarginRight = $(this).find("font").length > 0 ? Number($(this).find("font").css("marginRight").replace(/px/, "")) : 0;
                            var iWidth = $(this).find("i").length > 0 ? $(this).find("i")[0].offsetWidth : 0;
                            var iMarginLeft = $(this).find("i").length > 0 ? Number($(this).find("i").css("marginLeft").replace(/px/, "")) : 0;
                            var iMarginRight = $(this).find("i").length > 0 ? Number($(this).find("i").css("marginRight").replace(/px/, "")) : 0;
                            liWidthArray.push(spanWidth + spanMarginLeft + spanMarginRight + spanLeft + fontWidth + fontMarginLeft + fontMarginRight + iWidth + iMarginLeft + iMarginRight + 10);
                        });
                        liWidthArray.sort(function(x, y) {
                            return y - x;
                        });
                        var liOrgWidth = $lis[0].offsetWidth;
                        var width = liOrgWidth > liWidthArray[0] ? liOrgWidth : liWidthArray[0];
                        var fixWidth = !isNaN($attrs["fixwidth"]) ? Number($attrs["fixwidth"]) : 0;
                        if (width > $elem.width()) {
                            $lis.width(width + fixWidth).css("overflow", "hidden");
                            $uls.width(width + fixWidth);
                        }
                    }catch(e){
                        console.log("元素为空，不做修复");
                    }
                }, 2500);
                return promise;
            }
        }
    };
}]);